export default {
    direct: 'direct',
    batch: 'batch',
    longtask: 'longtask',
    email: 'email',
    blocked: 'blocked'
}
